// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"210":"247eeb68","999":"c9f101e2"}[chunkId] + ".chunk.js";
};